exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputIsentoChecked[data-v-79e7fc60]{background-color:#ede56a}.email-helper-text[data-v-79e7fc60]{display:block;margin-bottom:6px}", ""]);

// exports
